import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PageTitle from '../../Components/PageTitle';
import { routes } from '../../routes';


function PackageDetails() {
	return (
		<>
			<PageTitle title="Web Development Package" />
			<div className="page_content_section">
				<div className="plans_section bg-light pt-5 pb-4">
					<Container>
						<Row className="justify-content-center pt-3 pb-3">
							<Col xl={4} lg={4} md={6} sm={6} xs={12}>
								<div className="plan_item">
									<div className="plan_catg">
										<span>Basic Plan</span>
									</div>
									<div className="plan_price">
										<h2><small>$</small>50/ <small>month</small></h2>
									</div>
									<div className="plan_info">
										<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate placeat modi minus aspernatur tempore commodi.</p>
									</div>
									<hr />
									<div className="plan_features">
										<ul>
											<li>Lorem ipsum dolor sit amet.</li>
											<li>Consectetur adipisicing elit</li>
											<li>Ipsum dolor sit amet, consectetur</li>
											<li>Laborum impedit officiis quam</li>
											<li>Tempore excepturi cumque deleniti</li>
											<li>Cum aliquam voluptates voluptatem</li>
											<li>Excepturi cumque deleniti cum aliquam </li>
										</ul>
									</div>
									<div className="primary_btn text-center">
										<Link to={routes}>Choose Plan</Link>
									</div>
								</div>
							</Col>
							<Col xl={4} lg={4} md={6} sm={6} xs={12}>
								<div className="plan_item">
									<div className="plan_catg">
										<span>Standard Plan</span>
									</div>
									<div className="plan_price">
										<h2><small>$</small>99/ <small>month</small></h2>
									</div>
									<div className="plan_info">
										<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate placeat modi minus aspernatur tempore commodi.</p>
									</div>
									<hr />
									<div className="plan_features">
										<ul>
											<li>Lorem ipsum dolor sit amet.</li>
											<li>Consectetur adipisicing elit</li>
											<li>Ipsum dolor sit amet, consectetur</li>
											<li>Laborum impedit officiis quam</li>
											<li>Tempore excepturi cumque deleniti</li>
											<li>Cum aliquam voluptates voluptatem</li>
											<li>Excepturi cumque deleniti cum aliquam </li>
										</ul>
									</div>
									<div className="primary_btn text-center">
										<Link to={routes}>Choose Plan</Link>
									</div>
								</div>
							</Col>
							<Col xl={4} lg={4} md={6} sm={6} xs={12}>
								<div className="plan_item">
									<div className="plan_catg">
										<span>Advanced Plan</span>
									</div>
									<div className="plan_price">
										<h2><small>$</small>150/ <small>month</small></h2>
									</div>
									<div className="plan_info">
										<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate placeat modi minus aspernatur tempore commodi.</p>
									</div>
									<hr />
									<div className="plan_features">
										<ul>
											<li>Lorem ipsum dolor sit amet.</li>
											<li>Consectetur adipisicing elit</li>
											<li>Ipsum dolor sit amet, consectetur</li>
											<li>Laborum impedit officiis quam</li>
											<li>Tempore excepturi cumque deleniti</li>
											<li>Cum aliquam voluptates voluptatem</li>
											<li>Excepturi cumque deleniti cum aliquam </li>
										</ul>
									</div>
									<div className="primary_btn text-center">
										<Link to={routes}>Choose Plan</Link>
									</div>
								</div>
							</Col>
						</Row>
					</Container>
				</div>
			</div>
		</>
	);
}

export default PackageDetails;
